export const hasEmptyPartNumber = (partNumbers: string[]) =>
  partNumbers.some(partNumber => partNumber === '');
